import "../../common/common.css";
import "../../common/buttons.css";
import "../../common/logo.css";
import "./chat.css";
import "./login_popup.css";
import "./stickers.css";
import "./ban.css";
import "./wf.css";
